import Icon from "@ui/atoms/Icon/Icon";
import * as RouteHelper from "@utils/paths";
import { ContractorPackageLineItem } from "catchment-common/interfaces/contractorPackage";
import { ProjectLineItem } from "catchment-common/interfaces/project";
import { NavItemType } from "types";

import { safeUrl } from "./menuItemUrl";

/**
 * The project's Overview group — the dashboard, and nothing else.
 *
 * It used to be the first row of the Analytics group, which put the page that
 * summarises the whole project under a caption naming one part of it. The
 * design gives it its own group in both scopes, so the organisation's
 * "Overview / Dashboard" and a project's now read the same way.
 *
 * Not built for the shared (Level1Only) nav: that one is deliberately a single
 * flat list with no captions, so its dashboard stays where it was — see
 * `getPackageNav`.
 */
export const getOverviewNav = (
  project?: ProjectLineItem,
  contractorPackage?: ContractorPackageLineItem
): NavItemType => ({
  children: [
    {
      // `home`, matching the organisation's own Dashboard row: within a scope
      // this is the row you come back to.
      icon: <Icon name="home" />,
      id: "dashboard",
      title: "Dashboard",
      type: "item",
      url: safeUrl(project, contractorPackage, () =>
        RouteHelper.contractorDashboard(project!.id, contractorPackage!.id)
      )
    }
  ],
  id: "overview",
  title: "overview",
  type: "group"
});
